import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';

export interface Suffix {
  title: string;
  color?: string;
  default?: boolean;
  className?: string;
  backgroundColor?: string;
  borderColor?: string;
}

export interface Prefix {
  title: string;
  color?: string;
  default?: boolean;
  className?: string;
  backgroundColor?: string;
  borderColor?: string;
}

export interface RadioOption {
  value: string | boolean;
  label: string;
  icon?: string;
  suffix?: Suffix;
  prefix?: Prefix;
}

@Component({
    selector: 'pr-input-radio',
    templateUrl: './pr-input-radio.component.html',
    styleUrls: ['./pr-input-radio.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputRadioComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PrInputRadioComponent,
        },
    ],
    standalone: false
})
export class PrInputRadioComponent
  implements ControlValueAccessor, Validator, OnInit
{
  @ViewChild('input', { static: true }) inputRef: ElementRef;
  @Input() formControlName: string;
  @Input() derrors = false;
  @Input() label: string;
  @Input() tooltipButton: string;
  @Input() disable = false;
  @Input() isDefault = true;
  @Input() toggle = false;
  @Input() toggleBgEmpty = false;
  @Input() columns = 2;
  @Input() defaultValue?: string | boolean;
  @Input() options: RadioOption[] = [
    {
      value: true,
      label: 'Oui',
    },
    {
      value: false,
      label: 'Non',
    },
  ];
  @Output() onCheck: EventEmitter<any> = new EventEmitter();
  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  value;
  date: string = null;
  touched = false;

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  get formLabel() {
    return `${this.formControlName}_${this.hash}`;
  }

  onChange = val => {};

  onTouched = () => {};

  ngOnInit() {
    if (this.control) {
      if (
        (this.control.value === null || this.control.value === undefined) &&
        this.defaultValue !== undefined
      ) {
        this.control.setValue(this.defaultValue);
        this.control.markAsDirty();
        this.value = this.defaultValue;
      } else {
        this.value = this.control.value;
      }
    } else {
      this.value = this.options[1].value;
    }
  }

  checked(option: RadioOption): boolean {
    return this.value === option.value;
  }

  onInputChange(option: RadioOption): void {
    this.onCheck.emit(option.value);
    this.value = option.value;
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
